<template>
  <div>
    <div class="vasion-container-flex vasion-white-background">
      <div :class="{'z-index-fix': !isDisplayingNavBarDialog}" v-show="isSignedIn && !isVasionHome && activeSubAppSet && isLoginRouteNotActive && !isSignatureDocLinkView && !doHide">
        <TheMainSideNav v-if="apiToken" class="side-bar" :class="{'small-screen-collapse': !isMobileSideBarActive}" />
      </div>

      <!-- SIGNATURE DOCUMENT LINK PAGES -->
      <div v-if="isSignatureDocLinkView">
        <NavBar @showDialog="navBarDialog" />
        <transition name="component-fade" mode="out-in">
          <router-view v-if="activeSubAppSet" :key="$route.fullPath" to="/" />
        </transition>
      </div>

      <!-- VALID PAGES -->
      <div v-else-if="isSignedIn && isLoginRouteNotActive" class="main-class-view" :class="{'vasion-main-nav-mini-mode': !mainNavExpanded, 'vasion-main-nav-full-mode': mainNavExpanded, 'vasion-home-mode': isVasionHome, 'z-index-fix': isDisplayingNavBarDialog, 'full-width': mainContainerWithFullWidth}"> 
        <div
          v-if="!isVasionHome"
          id="overlay"
          :class="{'overlay-effect': isMobileSideBarActive}"
          @click="isMobileSideBarActive = false"
        />
        <div v-if="!doHide" class="top-bar">
          <div v-if="isSignedIn && !isVasionHome" class="mobile-side-bar-toggle" @click="isMobileSideBarActive = true">
            <VasionMenu v-if="!isMobileSideBarActive" class="hamburger-icon" />
          </div>
          <div v-if="isMobileSideBarActive && !isVasionHome" class="side-bar-close-button" @click="isMobileSideBarActive = !isMobileSideBarActive">
            <VasionCloseIcon class="side-bar-close-icon" />
          </div>
          <NavBar @showDialog="navBarDialog" class="nav" />
        </div>
        <transition name="component-fade" mode="out-in">
          <router-view v-if="activeSubAppSet" :key="$route.fullPath" to="/" />
        </transition>
      </div>

      <!-- INVALID PAGE -->
      <div v-else>
        <NavBar />
        <transition name="component-fade" mode="out-in">
          <router-view to="/" />
        </transition>
      </div>
    </div>
    <md-dialog id="timeout-error" :md-active.sync="showNetworkTimeoutModal" :md-click-outside-to-close="false">
      <div class="dialog-div">
        <h1>Are you still there?</h1>
        <div id="dialog-message" ref="dialogMessage">
          It seems that you have left. Would you like to stay logged in?<br />
          You will be automatically logged out in {{ userLogoutIn }} seconds.
        </div>
        <div class="button-div">
          <VasionButton id="btnSignout" :classProp="'secondary'" @vasionButtonClicked="signOut">
            LOGOUT
          </VasionButton>
          <VasionButton id="btnStayLoggedIn" :classProp="'primary'" @vasionButtonClicked="stayLoggedIn">
            I'M STILL HERE
          </VasionButton>
        </div>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import NavBar from '@/components/mainViews/NavBar.vue';
import TheMainSideNav from '@/components/mainViews/TheMainSideNav.vue';

export default {
  name: 'TheMainView',
  components: {
    NavBar,
    TheMainSideNav,
  },
  data: function () {
    return {
      doHide: false,
      isDisplayingNavBarDialog: false,
      isMobileSideBarActive: false,
      menuVisible: false,
      userLogoutCountdown: null,
      userLogoutIn: 0,
      userTimeoutCheck: null,
    }
  },
  computed: {
    activeSubAppSet() { return this.$store.state.mainViews.activeSubApp !== null },
    apiToken() { return this.$store.state.common.apiToken },
    hideNavbarAndHeader() { return this.$store.state.common.hideNavbarAndHeader },
    isLoginRouteNotActive() { return this.$route.name !== 'TheLogin' },
    isSignatureDocLinkView() { return this.$store.state.common.isSignatureDocLinkView },
    isSignedIn() { return this.$store.state.common.isSignedIn },
    isVasionHome() { return this.$store.state.mainViews.vasionHomeToggle },
    mainContainerWithFullWidth() { return this.$store.state.common.mainContainerWithFullWidth },
    mainNavExpanded() { return this.$store.state.mainViews.mainNavExpanded },
    needsPasswordReset() { return this.$store.state.common.needsPasswordReset },
    showNetworkTimeoutModal() { return this.$store.state.mainViews.showNetworkTimeoutModal },
    userSessionExpiry() { return this.$store.state.common.userSessionExpiry },
  },
  watch: {
    hideNavbarAndHeader() { this.doHide = this.hideNavbarAndHeader },
    isSignedIn: function (value) { 
      if (value) {
        this.$store.dispatch('admin/getUserSetting', 'defaultApp')
        this.createUserSessionTimer()
      } else {
        clearInterval(this.userTimeoutCheck)
        clearInterval(this.userLogoutCountdown)
      }
    },
  },
  created() {
    if (this.isSignedIn) {
      this.$store.dispatch('admin/getUserSetting', 'defaultApp')
    }
  },
  mounted() {
    this.createUserSessionTimer()
  },
  beforeDestroy () {
    clearInterval(this.userTimeoutCheck)
    clearInterval(this.userLogoutCountdown)
  },
  methods: {
    createUserSessionTimer() {
      clearInterval(this.userLogoutCountdown)
      if (this.isSignedIn && this.userSessionExpiry) {
        this.userTimeoutCheck = setInterval(() => {
          const now = new Date().getTime()
          if (this.userSessionExpiry - now <= 75000) {
            this.$store.dispatch('mainViews/setNetworkTimeoutModal', true)
            clearInterval(this.userTimeoutCheck)
            this.userLogoutIn = Math.round((this.userSessionExpiry - now)/1000 - 5)
            this.userLogoutCountdown = setInterval( () => {
              this.userLogoutIn = Math.round((this.userSessionExpiry - new Date().getTime())/1000 - 5)
              if (this.isSignedIn && this.userLogoutIn <= 0) {
                this.signOut()
              }
            }, 1000)
          }
        }, 10000)
      }
    },
    navBarDialog(showing) { this.isDisplayingNavBarDialog = showing },
    async signOut() {
      clearInterval(this.userTimeoutCheck)
      clearInterval(this.userLogoutCountdown)
      try {
        await this.$store.dispatch('common/signOut')
      } catch {
        console.warn('You have been signed out.')
      }
      this.$router.push({ name: 'TheLogin' })
    },
    async stayLoggedIn() { 
      await this.$store.dispatch('common/checkIsAuthenticated')
      this.toggleNetworkTimeoutModal()
      this.createUserSessionTimer()
    },
    toggleMenu() { this.menuVisible = !this.menuVisible },
    toggleNetworkTimeoutModal() { this.$store.dispatch('mainViews/setNetworkTimeoutModal', !this.showNetworkTimeoutModal) },
  },
}
</script>

<style lang="scss" scoped>
    @import '@/assets/css/variables.scss';

    .top-bar{
      display: flex;
      width:100%;
    }

    .nav{
      width: 100%;
    }

    .mobile-side-bar-toggle{
      display: none;
    }

    hamburger-icon{
      display: none;
    }

    side-bar-close-button{
      display: none;
    }

    @media (max-width: 950px) {
      
      .main-class-view {
        width: 100%;
      }
      .side-bar{
        visibility: visible;
        transition: .275s;
        width: 256px;
        position: absolute;
        left: 0;
        z-index: 5;
      }

      .small-screen-collapse{
        width: 0px;
        position: absolute;
        visibility: hidden;
        transition: .275s;
        left: 0;
        z-index: 5;
      }

      .mobile-side-bar-toggle{
        width: 56px;
        height: 56px;
        background-color: $plumb-500;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .hamburger-icon{
        padding: 0px;
        margin: 0px;
        fill: $orange-300;
      }

      .side-bar-close-button{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border-radius: 16px;
        background-color: rgba(255, 255, 255, 0.2);
        position: absolute;
        top: 0;
        left: 268px;
        margin-top: 12px;
        z-index: 6;

      }

      .side-bar-close-icon path{
        fill: white !important;
      }

      .overlay-effect{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 1;
        transition: .5s ease;
        background-color: rgba(0,0,0, 0.4);
        overflow:hidden;
        z-index: 6;
      }
    }

    .vasion-container-flex{
        display: flex;
    }

    .dialog-div {
      text-align: center;
      padding: 15px 10px 0px 10px;
      height: 190px;
      width: 450px;
    }

    .button-div {
      position: relative;
      top: 10px;
      margin: 0 auto;
    }

    .z-index-fix {
      position: relative;
      z-index: 7;
    }
    .full-width {
      width: 100vw;
    }
</style>
